// extracted by mini-css-extract-plugin
export var screen1 = "style-module--screen1--b9fd6";
export var screen1__info = "style-module--screen1__info--42b77";
export var screen1__subtitle = "style-module--screen1__subtitle--3cd43";
export var screen1__text = "style-module--screen1__text--a123e";
export var screen1__title = "style-module--screen1__title--757c1";
export var screen1__wrapper = "style-module--screen1__wrapper--bd030";